/* @flow */

import * as React from 'react';

import { PictoArrowDown } from '../../pictos/Element';
import './PlaceholderTVEpisode.css';

const PlaceholderTVEpisode = (): React.Node => (
  <div className='episode tv'>
    <div className='header'>
      <div className='dateAndTitle placeholder'>
        <div className='date' />
        <div className='title' />
      </div>
      <div className='actions'>
        <PictoArrowDown className='arrow' />
      </div>
    </div>
  </div>
);

export default PlaceholderTVEpisode;
